var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 179,
    viewBox: "0 0 151 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 167.279C116.921 167.279 150.5 133.7 150.5 92.2786C150.5 50.8573 116.921 17.2786 75.5 17.2786C34.0786 17.2786 0.5 50.8573 0.5 92.2786C0.5 133.7 34.0786 167.279 75.5 167.279Z",
    fill: "url(#paint0_linear_584_5467)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_584_5467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.5 60.2786H32.5C29.7386 60.2786 27.5 62.5172 27.5 65.2786V170.279C27.5 173.04 29.7386 175.279 32.5 175.279H118.5C121.261 175.279 123.5 173.04 123.5 170.279V65.2786C123.5 62.5172 121.261 60.2786 118.5 60.2786Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 75.2786H39.5C37.8431 75.2786 36.5 76.6218 36.5 78.2786C36.5 79.9355 37.8431 81.2786 39.5 81.2786H65.5C67.1569 81.2786 68.5 79.9355 68.5 78.2786C68.5 76.6218 67.1569 75.2786 65.5 75.2786Z",
    fill: "#D8D8D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 88.2786H39.5C37.8431 88.2786 36.5 89.6218 36.5 91.2786C36.5 92.9355 37.8431 94.2786 39.5 94.2786H83.5C85.1569 94.2786 86.5 92.9355 86.5 91.2786C86.5 89.6218 85.1569 88.2786 83.5 88.2786Z",
    fill: "#E9E9E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 102.279H39.5C37.8431 102.279 36.5 103.622 36.5 105.279C36.5 106.935 37.8431 108.279 39.5 108.279H65.5C67.1569 108.279 68.5 106.935 68.5 105.279C68.5 103.622 67.1569 102.279 65.5 102.279Z",
    fill: "#D8D8D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 115.279H39.5C37.8431 115.279 36.5 116.622 36.5 118.279C36.5 119.935 37.8431 121.279 39.5 121.279H83.5C85.1569 121.279 86.5 119.935 86.5 118.279C86.5 116.622 85.1569 115.279 83.5 115.279Z",
    fill: "#E9E9E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 129.279H39.5C37.8431 129.279 36.5 130.622 36.5 132.279C36.5 133.935 37.8431 135.279 39.5 135.279H65.5C67.1569 135.279 68.5 133.935 68.5 132.279C68.5 130.622 67.1569 129.279 65.5 129.279Z",
    fill: "#D8D8D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 142.279H39.5C37.8431 142.279 36.5 143.622 36.5 145.279C36.5 146.935 37.8431 148.279 39.5 148.279H83.5C85.1569 148.279 86.5 146.935 86.5 145.279C86.5 143.622 85.1569 142.279 83.5 142.279Z",
    fill: "#E9E9E9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_584_5467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.5 9.27863H32.5C29.7386 9.27863 27.5 11.5172 27.5 14.2786V44.2786C27.5 47.0401 29.7386 49.2786 32.5 49.2786H118.5C121.261 49.2786 123.5 47.0401 123.5 44.2786V14.2786C123.5 11.5172 121.261 9.27863 118.5 9.27863Z",
    fill: "#FDA29B"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 20.2786H39.5C37.8431 20.2786 36.5 21.6218 36.5 23.2786C36.5 24.9355 37.8431 26.2786 39.5 26.2786H65.5C67.1569 26.2786 68.5 24.9355 68.5 23.2786C68.5 21.6218 67.1569 20.2786 65.5 20.2786Z",
    fill: "#D8D8D8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 33.2786H39.5C37.8431 33.2786 36.5 34.6218 36.5 36.2786C36.5 37.9355 37.8431 39.2786 39.5 39.2786H83.5C85.1569 39.2786 86.5 37.9355 86.5 36.2786C86.5 34.6218 85.1569 33.2786 83.5 33.2786Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_584_5467",
    x: 21.5,
    y: 51.2786,
    width: 108,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_584_5467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_584_5467",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_584_5467",
    x: 21.5,
    y: 0.278625,
    width: 108,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_584_5467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_584_5467",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_584_5467",
    x1: 75.5,
    y1: 17.2786,
    x2: 75.5,
    y2: 167.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.ccfb99b717fbb47dde31b2fd02a9c57b.svg";
export { ForwardRef as ReactComponent };